import { MessageV2DTO } from 'support/types';

export type ClonedMessageV2DTO = Omit<MessageV2DTO, 'cloned_message_id'> &
  Required<Pick<MessageV2DTO, 'cloned_message_id'>> & {
    cloned_message_id: NonNullable<MessageV2DTO['cloned_message_id']>;
  };

export const isDocumentClone = (message: MessageV2DTO | undefined): message is ClonedMessageV2DTO => {
  if (!message) {
    return false;
  }

  return !!message.cloned_message_id;
};
